import React from 'react';
import _ from 'lodash';
import NewTabLink from '../../components/NewTabLink';
import { getTicketLink } from '../ticketViewer/links';

export const TRUCK = 'Truck';
export const UNAVAILABLE = 'unavailable';

export const hasOtherDepartments = (inputDepartments, departmentName) => {
  /* Returns a new array of departments that don't match departmentName */
  const results = _.reject(inputDepartments, (dept) => {
    return dept.name === departmentName;
  });

  return results.length === 0;
};

export const getTicketState = (ticketNumber) => {
  if (!ticketNumber) {
    return null;
  }
  if (!ticketNumber.ticket) {
    return 'unavailable';
  }
  return ticketNumber.ticket.state;
};

export const renderTicketNumber = (ticketNumber) => {
  const ticketState = getTicketState(ticketNumber);
  const isClickable = (ticketNumber && ticketState !== UNAVAILABLE);

  if (isClickable) {
    let ticketId = '';
    let jobId = '';
    if (ticketNumber && ticketNumber.ticket) {
      ticketId = ticketNumber.ticket.id;
      jobId = ticketNumber.ticket.job.id;
    }
    const url = getTicketLink(ticketId, jobId);
    return (
      <NewTabLink to={url}>
        {ticketNumber.number}
      </NewTabLink>
    );
  }

  return (ticketNumber.number);
};
